import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0 0 0;
  width: 100%;
  align-content: center;
  align-self: center;

  button {
    margin-top: 1rem;
  }
`;

export const Graph = styled.div`
  height: calc(100vh - 6rem);
`;

export const ContainerForm = styled(Form)`
  /* height: 6rem; */
  > div:not(:last-child) {
    margin-bottom: 2rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  /* height: calc(10vh - 6rem); */
`;

export const FormWrapper = styled(Form)`
  flex: 1;
  display: flex;
  flex-direction: column;

  > div:not(:last-child) {
    margin-bottom: 1rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0 !important;
  }

  /* Input {
    text-align : right;
  } */
  `;

export const WrapperRadioGroup = styled.div`
  padding-bottom: 1rem;
`;
